export const dayOfWeeks = ['日', '月', '火', '水', '木', '金', '土'];
